import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

// Native APNs / FCM. The page POSTs /devices with the session cookie;
// the shell only asks the OS for a token.
export default class extends BridgeComponent {
  static component = 'push';

  ask() {
    this.send('ask', {}, ({ data } = {}) => {
      const token = data?.token;
      if (!token) return;
      fetch(this.bridgeElement.bridgeAttribute('url') || '/devices', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
        },
        body: JSON.stringify({ token, os: data.os }),
      });
    });
  }
}
